export const bannerServicesTextContent = {
  content: [
    {
      titleText: (
        <>
          World-Class <span>Slot Game Development</span>
        </>
      ),
      paraText:
        "Full-fledged and technically forward slot game software development and design company that offers your slot gaming business feature-rich games with intuitive design elements for an unforgettable gaming experience! Hire slot game designers, artists, and developers from GammaStack and fulfill your branded slot game requirements in complete quality and timeliness!",
      btnText: "Contact Us",
      imageSrc: "/assets/stock-img/banner_character_img_05.webp",
    },
  ],
};
